import { useEffect } from 'react';
import { dispatch } from 'nike-re-framejs';
import { cleanBoxStore, initBoxStore } from '@/nikeone/handlers';

function useBoxStore(boxStore, options, boxIds) {
    const boxIdsDep = boxIds && boxIds.length ? boxIds.join('-') : '';
    useEffect(() => {
        dispatch(initBoxStore(boxStore, options, boxIds));
        if (!(boxStore === 'betbook')) {
            return () => dispatch(cleanBoxStore(boxStore));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boxStore, options, boxIdsDep]);
}

export default useBoxStore;
